import type { ArtFile } from './assets';

/** Event cards. Raster pack: avif, then webp, then the original jpeg. */
export const EVENT_BANNERS: readonly { key: string; path: string }[] = [
  { key: 'banner-acorn-rush', path: 'assets/events/banner-acorn-rush.jpg' },
  { key: 'banner-thornfall', path: 'assets/events/banner-thornfall.jpg' },
  { key: 'banner-honey-hunt', path: 'assets/events/banner-honey-hunt.jpg' },
  { key: 'banner-firefly-night', path: 'assets/events/banner-firefly-night.jpg' },
  { key: 'banner-frozen-pond', path: 'assets/events/banner-frozen-pond.jpg' },
  { key: 'banner-mushroom-maze', path: 'assets/events/banner-mushroom-maze.jpg' },
  { key: 'banner-win-streak', path: 'assets/events/banner-win-streak.jpg' },
  { key: 'banner-trophy-road', path: 'assets/events/banner-trophy-road.jpg' },
  { key: 'banner-glen-rumble', path: 'assets/events/banner-glen-rumble.jpg' },
  { key: 'banner-riverbank-relay', path: 'assets/events/banner-riverbank-relay.jpg' },
  { key: 'banner-harvest-showdown', path: 'assets/events/banner-harvest-showdown.jpg' },
  { key: 'banner-moonlit-duel', path: 'assets/events/banner-moonlit-duel.jpg' },
  { key: 'banner-thicket-tournament', path: 'assets/events/banner-thicket-tournament.jpg' },
  { key: 'banner-bramble-brawl', path: 'assets/events/banner-bramble-brawl.jpg' },
];

/** Daily Spin paintings. WebP keeps the alpha on the wheel and the buttons. */
export const SPIN_ART: readonly { key: string; path: string; pack: ArtFile['pack'] }[] = [
  { key: 'spin-under', path: 'assets/bg/spin/under.png', pack: 'webp' },
  { key: 'spin-disc', path: 'assets/bg/spin/disc.png', pack: 'webp' },
  { key: 'spin-pointer', path: 'assets/bg/spin/pointer.png', pack: 'webp' },
  { key: 'spin-btn', path: 'assets/ui/spin/btn_spin.png', pack: 'webp' },
  { key: 'spin-icon', path: 'assets/ui/spin/spin_icon.png', pack: 'webp' },
  { key: 'spin-odds-btn', path: 'assets/ui/spin/btn_odds.png', pack: 'webp' },
];

const REWARD_NAMES = ['acorns', 'honey', 'gift', 'tricks', 'crown', 'charm'] as const;

export function menuArtFiles(): ArtFile[] {
  const files: ArtFile[] = [];
  for (const banner of EVENT_BANNERS) files.push({ key: banner.key, path: banner.path, pack: 'raster' });
  for (const file of SPIN_ART) files.push({ key: file.key, path: file.path, pack: file.pack });
  for (const name of REWARD_NAMES) {
    files.push({ key: `reward-${name}`, path: `assets/ui/rewards/reward-${name}.png`, pack: 'webp' });
  }
  return files;
}
